import { render, staticRenderFns } from "./riskDialog.vue?vue&type=template&id=1dbcf062&scoped=true&"
import script from "./riskDialog.vue?vue&type=script&lang=ts&"
export * from "./riskDialog.vue?vue&type=script&lang=ts&"
import style0 from "./riskDialog.vue?vue&type=style&index=0&id=1dbcf062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbcf062",
  null
  
)

export default component.exports